/**
 * Ids of the built-in driver-view columns that other modules place or look up by id, so a rename of an `accessorKey`
 * cannot silently drift from the code that depends on it.
 */

/** The Most Recent Driver Message column. */
export const RECENT_MESSAGE_COLUMN_ID = "recentMessage";
/** The Message time column, which shows when the row's most recent driver message was sent. */
export const MESSAGE_TIME_COLUMN_ID = "latestItemCreatedAt";
